import { useState } from "react";

import { POST_CANNED_RESPONSE_ACTIONS } from "../../FormsPostFormBranchesList/enums";
import { Dropdown, DropdownItem, DropdownMenu } from "reactstrap";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import {
    CANNED_RESPONSE_DELETE_PERMISSION,
    CANNED_RESPONSE_READ_PERMISSION,
    CANNED_RESPONSE_UPDATE_PERMISSION,
} from "../../CannedResponses/permissions";

import "./FormCannedResponse.scss";

const { EDIT_CANNED_RESPONSE, VIEW_CANNED_RESPONSE, DELETE_CANNED_RESPONSE } =
    POST_CANNED_RESPONSE_ACTIONS;

const dropDownItems = [
    {
        baseResources: CANNED_RESPONSE_READ_PERMISSION,
        actionType: VIEW_CANNED_RESPONSE,
        title: "View",
    },
    {
        baseResources: CANNED_RESPONSE_UPDATE_PERMISSION,
        actionType: EDIT_CANNED_RESPONSE,
        title: "Edit",
    },
    {
        baseResources: CANNED_RESPONSE_DELETE_PERMISSION,
        actionType: DELETE_CANNED_RESPONSE,
        title: "Delete",
    },
];

const FormCannedResponse = ({
    handleCannedResponseActions,
    cannedResponse,
}) => {
    const [show, toggleShow] = useState(false);
    return (
        <Dropdown
            isOpen={show}
            className='form-canned-response'
            direction='up'
            toggle={() => toggleShow((prevState) => !prevState)}>
            <div
                className='form-canned-response__content'
                onClick={() => toggleShow((prevState) => !prevState)}>
                <span>{cannedResponse?.title}</span>
            </div>
            <DropdownMenu className='capsule__bottom__menu'>
                {dropDownItems.map(({ baseResources, title, actionType }, key) => (
                    <ComponentAccessControl baseResources={baseResources} key={key}>
                        <DropdownItem>
                            <p
                                onClick={() =>
                                    handleCannedResponseActions(
                                        actionType,
                                        cannedResponse
                                    )
                                }>
                                {title}
                            </p>
                        </DropdownItem>
                    </ComponentAccessControl>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default FormCannedResponse;
